export default {
  namespaced: true,
  state: {
    info: "主要信息",
  },
  getters: {},
  mutation: {},
  actions: {},
};
